// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_32-1";
export var rateTableServiceLevelDropdown = "_32-3";
export var rateTableTypeDropdown = "_32-0";
export var rateTableValueModeDropdown = "_32-2";